import { SharedConfig } from '../../../shared/shared.config';
import { environment } from './environment';

export const ApplicationConfig = {
  ...SharedConfig,

  WEB_ENDPOINT: environment.production
    ? 'https://timekit.by/'
    : 'http://localhost:4200/',

  API_ENDPOINT: {
    'localhost': 'http://localhost:8080/api/',
    // e2e stack: the test frontend is opened via 127.0.0.1 so it hits the test backend on 8081,
    // not the dev backend on 8080 (which points at prod).
    '127.0.0.1': 'http://127.0.0.1:8081/api/',
    'timekit.by': 'https://server.timekit.by/api/',
    'ru.timekit.by': 'https://harrymath-shedule-crm-9c58.twc1.net/api/',
    'harrymath-shedule-crm-5d0b.twc1.net': 'https://server.timekit.by/api/',
    'harrymath-shedule-crm-f87f.twc1.net': 'https://harrymath-shedule-crm-9c58.twc1.net/api/'
  }[location.hostname]!
};
